const SysOptionsDetailPluginSettings: IPluginSettings = {
    name: 'Системные настройки',
    mnemocode: 'sys_options_detail_plugin',
    permission: 'SysOptionsDetail',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 100
        },
        {
            order: 1,
            propertyName: 'value',
            propertyType: 'string',
            displayName: 'Значение',
            visibility: true,
            width: 150
        },       
    ],
    detailsPlugins: [],
}

export default SysOptionsDetailPluginSettings
